import request from '@/utils/request'

export async function getData(data) {
  return request({
    url: '/label/vehicle/list',
    method: 'post',
    data,
  })
}
export async function deleteData(data) {
  return request({
    url: '/label/vehicle/delete',
    method: 'post',
    data,
  })
}
export async function createData(data) {
  return request({
    url: '/label/vehicle/save',
    method: 'post',
    data,
  })
}
export async function updateData(data) {
  return request({
    url: '/v2/label/vehicle/edit',
    method: 'post',
    data,
  })
}
export async function cancelData(data) {
  return request({
    url: '/label/vehicle/cancel',
    method: 'post',
    data,
  })
}
export async function detailData(data) {
  return request({
    url: '/label/vehicle/detail',
    method: 'post',
    data,
  })
}